import { MediaDisplay } from ".";
import { List } from "immutable";
import _ from "lodash";
import * as React from "react";
import { Link } from "react-router-dom";
import * as Comp from "../../../components";
import { Paths } from "../../../constants";
import { Legacy } from "../../../constants/paths";
import * as M from "../../../models";
import { Utility } from "../../../utils";

interface OwnProps {
    abstract: M.Abstract.Abstract;
    allowEdits?: boolean;
    allowUploads?: boolean;
    hideAuthors?: boolean;
    isAdmin?: boolean;
    type: M.Abstract.AbstractType;
}

interface OwnState {
}

export class AbstractSummary extends React.Component<OwnProps, OwnState> {
    public render() {
        const a = this.props.abstract;
        const mdash = <Comp.Generic.WrapperLess> &mdash; </Comp.Generic.WrapperLess>;
        const authors = List(a.authors);
        const primaryAuthors = authors.filter((x) => x !== undefined && x.isPrimary);
        const coAuthors = authors.filter((x) => x !== undefined && !x.isPrimary);
        const isAdmin = this.props.isAdmin;
        const status = _.find(M.Abstract.AbstractStatuses.Values, (v) => v.id === a.statusId);
        const invResp = _.find(M.Abstract.InvitationResponse.Values, (v) => v.id === a.invitationResponseId);

        const editLinkAuthorship = this.props.allowEdits
            ? <>
                {mdash}
                {isAdmin
                    ? <Link to={Paths.AdminAbstractEdit(a.eventId, a.guid)}>Edit</Link>
                    : <Link to={{ pathname: Paths.AbstractsCompose(a.eventId, "authorship", a.guid), state: "authorship"}}>Edit</Link>}
            </>
            : null;

        const editLinkDetails = this.props.allowEdits
            ? <>
                {mdash}
                {isAdmin
                    ? <Link to={Paths.AdminAbstractEditDetails(a.eventId, a.guid)}>Edit</Link>
                    : <Link to={{ pathname: Paths.AbstractsCompose(a.eventId, "details", a.guid), state: "details"}}>Edit</Link>}
            </>
            : null;

        const editLinkUploads = this.props.allowUploads
            ? <>
                {mdash}
                {isAdmin
                    ? <Link to={Paths.AdminAbstractEditUploads(a.eventId, a.guid)}>Edit</Link>
                    : <Link to={{ pathname: Paths.AbstractsCompose(a.eventId, "uploads", a.guid), state: "uploads"}}>Edit</Link>}
            </>
            : null;

        const editLinkPerms = isAdmin && this.props.allowEdits
            ? <>
                {mdash}
                <Link to={Paths.AdminAbstractEditPermissions(a.eventId, a.guid)}>Edit</Link>
            </>
            : null;

        const editLinkSettings = isAdmin && this.props.allowEdits
            ? <>
                {mdash}
                <Link to={Paths.AdminAbstractEditSettings(a.eventId, a.guid)}>Edit</Link>
            </>
            : null;

        const classification = this.props.type.classifications.length
            ? <Comp.Editors.ReviewField label="Classification">{a.classification || <p><em>None</em></p>}</Comp.Editors.ReviewField>
            : null;

        const presentingAuthorDisplay = primaryAuthors.size
            ? <div className="authors">
                <ul>
                    {primaryAuthors.map((x: M.Abstract.AbstractAuthor, i) => <li key={i}>
                        <Comp.Reusable.PersonSearchListItem
                            avatar={M.Generic.PersonHelper.getAvatarUrl(x)}
                            name={M.Generic.PersonHelper.getFullName(x)}
                            title={x.title}
                            email={x.email}
                            emailAsLink
                            link={this.props.isAdmin && x.legacyMemberId ? Legacy.AdminMemberProfile(x.legacyMemberId) : undefined}
                        />
                    </li>)}
                </ul>
            </div>
            : <p><em>None</em></p>;

        const profilePhotoDisplay = primaryAuthors
            .filter((x: M.Abstract.AbstractAuthor, i) => x.profilePicture !== null && x.showProfilePicture)
            .map((x: M.Abstract.AbstractAuthor, i) => {
                let profilePhoto = M.Generic.PersonHelper.getAvatarUrl(x);
                if (profilePhoto.indexOf("asrs.org/content") > -1)
                    profilePhoto += "/image-custom;ratio_crop$100,130;max$130,130.ImageHandler";
                return <p key={i}><img alt="" src={profilePhoto} style={{ width: "130px" }} /></p>;
            })
            .toArray();

        const coAuthorsDisplay = coAuthors.size
            ? <div className="authors">
                <ul>
                    {coAuthors.map((x: M.Abstract.AbstractAuthor, i) => <li key={i}>
                        <Comp.Reusable.PersonSearchListItem
                            avatar={M.Generic.PersonHelper.getAvatarUrl(x)}
                            name={M.Generic.PersonHelper.getFullName(x)}
                            title={x.title}
                            email={x.email}
                            emailAsLink
                            link={this.props.isAdmin && x.legacyMemberId ? Legacy.AdminMemberProfile(x.legacyMemberId) : undefined}
                        />
                    </li>)}
                </ul>
            </div>
            : <p><em>None</em></p>;

        const phoneDisplay = primaryAuthors
            .filter((x: M.Abstract.AbstractAuthor, i) => x.phone !== null && x.phone !== undefined && !Utility.isNullOrEmptyString(x.phone.number))
            .map((x: M.Abstract.AbstractAuthor, i) => {
                const name = primaryAuthors.size > 1
                    ? `(${M.Generic.PersonHelper.getFullName(x)})`
                    : "";
                return <p key={i}>{M.Contact.PhoneHelper.displayFormatted(x.phone)} {name}</p>;
            })
            .toArray();

        const formDetails = this.props.type.form
            ? <Comp.FormBuilder.FormSubmissionSummary
                form={this.props.type.form}
                submission={a.details}
                isAuthorReview={this.props.allowEdits}
                editLink={this.props.allowEdits
                        ? (isAdmin
                            ? Paths.AdminAbstractEditDetails(a.eventId, a.guid)
                            : Paths.AbstractsCompose(a.eventId, "details", a.guid))
                        : undefined}
            />
            : null;

        const details = classification !== null || formDetails !== null
            ? <Comp.Generic.WrapperLess>
                <h2>Details{editLinkDetails}</h2>
                {classification}
                {formDetails}
            </Comp.Generic.WrapperLess>
            : null;

        const uploads = this.props.type.typeMedia.map((tm, i) => {
            const media = a.media.filter((m) => m.abstractTypeMediaId === tm.id);
            if (media.length) {
                return <Comp.Editors.ReviewField key={i} label={tm.label}>
                    {media.map((m, j) => {
                    const caption = tm.promptCaption
                        ? <>
                            <p>Caption:</p>
                            {m.caption
                                ? <div dangerouslySetInnerHTML={{ __html: m.caption }} />
                                : <p><em>None</em></p>
                            }
                        </>
                        : null;

                    const keywords = tm.promptKeywords
                        ? <p>Keywords:{" "}
                            {m.tags.length
                                ? <>{Utility.joinSkipEmpty(m.tags.map((t) => t.name), ", ")}</>
                                : <em>None</em>
                            }
                        </p>
                        : null;

                    const title = tm.promptTitle
                        ? <p>Title: {m.title
                            ? <span dangerouslySetInnerHTML={{ __html: m.title }} />
                            : <em>None</em>
                        }</p>
                        : null;

                    return <Comp.Generic.WrapperLess key={j}>
                        <MediaDisplay media={m} />
                        {title}
                        {caption}
                        {keywords}
                    </Comp.Generic.WrapperLess>;
                    })}
                    </Comp.Editors.ReviewField>;
            }
            else
                return <Comp.Editors.ReviewField key={i} label={tm.label}><p><em>None</em></p></Comp.Editors.ReviewField>;
        });

        const uploadSummary = uploads.length
            ? <>
                <h2>Uploads{editLinkUploads}</h2>
                {uploads}
            </>
            : null;

        const permissions = this.props.isAdmin
            ? <>
                <hr />
                <h2>Permissions{editLinkPerms}</h2>
                <Comp.Editors.ReviewField label="Usage permission">I {a.agreedToUsagePermission ? "" : "dis"}agree</Comp.Editors.ReviewField>
                <Comp.Editors.ReviewField label="Repurposing of content">I {a.agreedToRepurposingContent ? "" : "dis"}agree</Comp.Editors.ReviewField>
                <Comp.Editors.ReviewField label="Speaker attestation">I {a.agreedToSpeakerGuidelines ? "" : "dis"}agree</Comp.Editors.ReviewField>
            </>
            : null;

        const adminSettings = this.props.isAdmin
            ? <>
                <hr />
                <h2>Admin settings{editLinkSettings}</h2>
                <Comp.Editors.ReviewField label="CME enabled">{a.cmeEnabled ? "Yes" : "No"}</Comp.Editors.ReviewField>
                {a.cmeEnabled ? <Comp.Editors.ReviewField label="CME hours">{a.cmeHours || "None"}</Comp.Editors.ReviewField> : null}
                <Comp.Editors.ReviewField label="Invitation response">{invResp ? invResp.name : "No response"}</Comp.Editors.ReviewField>
                <Comp.Editors.ReviewField label="Abstract status">{status ? status.name : "Unknown"}</Comp.Editors.ReviewField>
            </>
            : null;

        return <>
            <h2>Authorship{editLinkAuthorship}</h2>

            {isAdmin
                ? <Comp.Editors.ReviewField label="ID">{a.id}</Comp.Editors.ReviewField>
                : null}

            <Comp.Editors.ReviewField label="Presentation format">{a.type}</Comp.Editors.ReviewField>
            <Comp.Editors.ReviewField label="Title" isHtml>{a.title}</Comp.Editors.ReviewField>

            {this.props.hideAuthors ? null : <Comp.Editors.ReviewField label="Presenting author">{presentingAuthorDisplay}</Comp.Editors.ReviewField>}

            {this.props.hideAuthors
                ? null
                : <Comp.Editors.ReviewField label="Mobile phone">
                    {phoneDisplay.length ? phoneDisplay : <p><em>None</em></p>}
                </Comp.Editors.ReviewField>}

            {this.props.hideAuthors ? null : <Comp.Editors.ReviewField label="Co-author(s)">{coAuthorsDisplay}</Comp.Editors.ReviewField>}

            <Comp.Editors.ReviewField label="Keywords" isHtml>{a.keywords.length ? Utility.joinSkipEmpty(a.keywords, ", ") : "<em>None</em>"}</Comp.Editors.ReviewField>
            <Comp.Editors.ReviewField label="Study group" isHtml>{a.studyGroup || "<em>None</em>"}</Comp.Editors.ReviewField>

            {this.props.hideAuthors
                ? null
                : <Comp.Editors.ReviewField label="Profile photo">
                    {profilePhotoDisplay.length ? profilePhotoDisplay : <p><em>None</em></p>}
                </Comp.Editors.ReviewField>}

            {details}

            {uploadSummary}

            {permissions}

            {adminSettings}
        </>;
    }
}



// WEBPACK FOOTER //
// ./src/containers/abstracts/components/AbstractSummary.tsx